<template>
  <div style="padding: 15px;">
    <vxe-table border height="250" :data="tableData">
      <vxe-table-column field="orderCode" title="运输单号" min-width="250" />
      <vxe-table-column field="payAmount" title="运费金额" min-width="100" />
      <vxe-table-column field="totalMonthAmount" title="本月累计打款金额" min-width="140" />
      <vxe-table-column field="driverName" title="收款人" min-width="130" />
      <vxe-table-column field="driverPhone" title="手机号" min-width="130" />
    </vxe-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="goOnPay()" type="primary">继续打款</el-button>
      <el-button @click="cancelPay()">取消打款</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AllocateOil",
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    init(list) {
      this.tableData = list;
    },
    goOnPay() {
      this.$emit("goOnPay");
    },
    cancelPay() {
      this.$emit("cancelPay");
    },
  }
};
</script>
